var map = {
	"./banjo/duotone.jpg": 5669,
	"./cafler/duotone.jpg": 7338,
	"./dev/duotone.jpg": 6245,
	"./dibi/duotone.jpg": 2025,
	"./lapele/duotone.jpg": 8276,
	"./naggura/duotone.jpg": 9172,
	"./pronatal/duotone.jpg": 7103,
	"./soultek/duotone.jpg": 7014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2787;